import React, { Component } from 'react'

import {
    formHandler,
    Button,
    TextInput,
} from '../ui'
import RequestFormConfirmation from './request_form_confirmation'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as jobsActions from '../../actions/jobs'
import * as modalActions from '../../actions/modal'

class OvertimeRequestForm extends Component {
    static propTypes = {
        appState: React.PropTypes.object.isRequired,
        crewUUID: React.PropTypes.string.isRequired,
        jobUUID: React.PropTypes.string.isRequired,
        jobs: React.PropTypes.object.isRequired,
        jobsActions: React.PropTypes.object.isRequired,
        modalActions: React.PropTypes.object.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            data: {},
        }

        this._updateValue = formHandler.updateValue.bind(this)
    }

    _submitRequestForOvertime = () => {
        const data = {
            additional_hours: this.state.data.additional_hours,
            notes: this.state.data.notes,
        }

        this.props.jobsActions.submitRequestForOvertime(
            data,
            this.props.crewUUID,
            this.props.jobUUID,
            () => {
                this.props.modalActions.showModal({
                    component: (
                        <RequestFormConfirmation />
                    ),
                    modalProps: {
                        allowClose: true,
                        title: 'Overtime requested',
                    },
                })
            }
        )
    }

    render() {
        const errors = this.props.jobs.errors

        return (
            <div>
                <TextInput
                    error={ errors.additional_hours }
                    label="Additional hours on site"
                    name="additional_hours"
                    type="number"
                    updateValue={ this._updateValue }
                    value={ this.state.data.additional_hours }
                />
                <TextInput
                    error={ errors.notes }
                    label="Notes"
                    name="notes"
                    rows="6"
                    type="textarea"
                    updateValue={ this._updateValue }
                    value={ this.state.data.notes }
                />

                <Button
                    buttonOnly
                    loading={ this.props.appState.loading }
                    onClick={ this._submitRequestForOvertime }
                    status="primary"
                >
                    Request overtime
                </Button>
            </div>
        )
    }
}

export default connect(
    (state) => {
        return {
            appState: state.appState,
            jobs: state.jobs,
        }
    },
    (dispatch) => {
        return {
            jobsActions: bindActionCreators(jobsActions, dispatch),
            modalActions: bindActionCreators(modalActions, dispatch),
        }
    }
)(OvertimeRequestForm)



// WEBPACK FOOTER //
// ./app/components/jobs/overtime_request_form.js